import React, { useEffect, useState } from "react";
import conexio from "../../images/Assets/conexio.png";
import "swiper/swiper-bundle.css";
import Carousel, { slidesToShowPlugin } from "@brainhubeu/react-carousel";
import "@brainhubeu/react-carousel/lib/style.css";

export default function Customer() {
  const [slidesToShow, setSlidesToShow] = useState(getInitialSlidesToShow());

  useEffect(() => {
    function handleResize() {
      setSlidesToShow(getInitialSlidesToShow());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function getInitialSlidesToShow() {
    return window.innerWidth < 768 ? 1 : 2;
  }

  return (
    <div className="bg-[#FBFAFE] pt-20 pb-16">
      <div className="flex items-center justify-center">
        <div className="bg-[#F4F2FE] text-[14px] text-[#5B2ED9] font-gilroySemibold uppercase w-fit py-0.5 px-2.5 rounded-full">
          clients
        </div>
      </div>

      <div className="md:text-[28px] text-[40px] text-[#0E062A] text-center font-gilroySemibold mt-1">
        Success stories from our customers
      </div>

      <Carousel
        plugins={[
          "centered",
          "infinite",
          "arrows",
          {
            resolve: slidesToShowPlugin,
            options: {
              numberOfSlides: slidesToShow,
            },
          },
        ]}
        className="mt-7"
      >
        <div className="bg-[#F4F0FF] border border-[#F1ECFF] px-8 py-16 rounded-3xl flex flex-col items-center justify-center relative mx-2.5 w-full">
          <img src={conexio} alt="conexio" />

          <div className="md:text-[28px] text-[32px] text-[#0E062A] font-gilroySemibold mt-2">Conexio</div>

          <div className="text-[18px] text-[#544D68] font-gilroyRegular mt-3">
            Conexio is a fleet management Conexio delivers powerful apps for automakers and fleet owners to
            connect, control and commercialize their vehicle assets and services.
          </div>

          {/* <div className="bg-[#FFFFFF] p-3 rounded-full shadow-drop absolute left-6 cursor-pointer">
            <BsArrowLeft className="text-[18px]" onClick={handleLeftArrowClick} />
          </div>

          <div className="bg-[#FFFFFF] p-3 rounded-full shadow-drop absolute right-6 cursor-pointer">
            <BsArrowRight className="text-[18px]" onClick={handleRightArrowClick} />
          </div> */}
        </div>

        <div className="bg-[#F4F0FF] border border-[#F1ECFF] px-8 py-16 rounded-3xl flex flex-col items-center justify-center relative mx-2.5 w-full">
          <img src={conexio} alt="conexio" />

          <div className="md:text-[28px] text-[32px] text-[#0E062A] font-gilroySemibold mt-2">Conexio</div>

          <div className="text-[18px] text-[#544D68] font-gilroyRegular mt-3">
            Conexio is a fleet management Conexio delivers powerful apps for automakers and fleet owners to
            connect, control and commercialize their vehicle assets and services.
          </div>

          {/* <div className="bg-[#FFFFFF] p-3 rounded-full shadow-drop absolute left-6 cursor-pointer">
            <BsArrowLeft className="text-[18px]" onClick={handleLeftArrowClick} />
          </div>

          <div className="bg-[#FFFFFF] p-3 rounded-full shadow-drop absolute right-6 cursor-pointer">
            <BsArrowRight className="text-[18px]" onClick={handleRightArrowClick} />
          </div> */}
        </div>

        <div className="bg-[#F4F0FF] border border-[#F1ECFF] px-8 py-16 rounded-3xl flex flex-col items-center justify-center relative mx-2.5 w-full">
          <img src={conexio} alt="conexio" />

          <div className="md:text-[28px] text-[32px] text-[#0E062A] font-gilroySemibold mt-2">Conexio</div>

          <div className="text-[18px] text-[#544D68] font-gilroyRegular mt-3">
            Conexio is a fleet management Conexio delivers powerful apps for automakers and fleet owners to
            connect, control and commercialize their vehicle assets and services.
          </div>

          {/* <div className="bg-[#FFFFFF] p-3 rounded-full shadow-drop absolute left-6 cursor-pointer">
            <BsArrowLeft className="text-[18px]" onClick={handleLeftArrowClick} />
          </div>

          <div className="bg-[#FFFFFF] p-3 rounded-full shadow-drop absolute right-6 cursor-pointer">
            <BsArrowRight className="text-[18px]" onClick={handleRightArrowClick} />
          </div> */}
        </div>

        <div className="bg-[#F4F0FF] border border-[#F1ECFF] px-8 py-16 rounded-3xl flex flex-col items-center justify-center relative mx-2.5 w-full">
          <img src={conexio} alt="conexio" />

          <div className="md:text-[28px] text-[32px] text-[#0E062A] font-gilroySemibold mt-2">Conexio</div>

          <div className="text-[18px] text-[#544D68] font-gilroyRegular mt-3">
            Conexio is a fleet management Conexio delivers powerful apps for automakers and fleet owners to
            connect, control and commercialize their vehicle assets and services.
          </div>

          {/* <div className="bg-[#FFFFFF] p-3 rounded-full shadow-drop absolute left-6 cursor-pointer">
            <BsArrowLeft className="text-[18px]" onClick={handleLeftArrowClick} />
          </div>

          <div className="bg-[#FFFFFF] p-3 rounded-full shadow-drop absolute right-6 cursor-pointer">
            <BsArrowRight className="text-[18px]" onClick={handleRightArrowClick} />
          </div> */}
        </div>
      </Carousel>
    </div>
  );
}
